import {Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {DefaultApi} from '../service/default.api';



@Component({
    selector: 'socialLogin',
    templateUrl: './social-login.component.html',
    standalone: false
})
export class SocialLoginComponent implements OnInit{

    errorMessage = '';
    isRedirection = false;
    pluginName = 'SocialLoginComponent';
    constructor(
                private route: ActivatedRoute,
                private router: Router, private api: DefaultApi) {
    }
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.processQueryParams(params);
    });
    console.log('ngOnInit in `SocialLoginComponent` component');
  }
    processQueryParams(params) {
        this.isRedirection = !!params.plugin;
        if (!!params.success) {
          this.api.initSession().subscribe(() => {
            if (params.success === 'AC') { // show accept cookie form
              this.router.navigate(['accept_cookies']);
            } else if (params.success === 'O') { // success
              window.location.href = `/portals/`;
            }
          });
        } else if (!!params.error) {
            this.errorMessage = `Во время авторизации произошла ошибка ${params.error}`;
            setTimeout(() => {
                this.router.navigate(['/']);
            }, 3000);
        }
    }





}
